import { createReducer } from '@topconagriculture/frontend-utils';
import * as dotProp from 'dot-prop-immutable';
import { changeLanguage, getLanguages } from './language.actions';
export const initialState = { languages: [], currentLanguage: null };
const languageReducer = createReducer(initialState, {
    [getLanguages.done.type]: (state, action) => dotProp.set(state, 'languages', action.payload.result),
    [changeLanguage.done.type]: (state, action) => dotProp.set(state, 'currentLanguage', action.payload.result),
});
export default { language: languageReducer };
//# sourceMappingURL=language.reducer.js.map